import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { BasicForm } from "@components/shared";
import { useTranslation } from "react-i18next";

export default function UserForm({
  id = null,
  firstName = "",
  lastName = "",
  email = "",
  mfa = false,
  onSuccess = () => {},
  reqData = {},
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  function onSubmit(formData) {
    setLoading(true);

    if (id) return onUpdate(formData);

    return onCreate(formData);
  }

  function onCreate(formData) {
    const req = {
      ...reqData,
      ...formData,
    };

    axios
      .post(`/users/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("created")))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      user_id: id,
    };

    axios
      .put(`/users/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("updated")))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "first_name",
      label: t("first_name"),
      initialValue: firstName,
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "last_name",
      label: t("last_name"),
      initialValue: lastName,
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "email",
      label: t("email"),
      initialValue: email,
      required: true,
      schema: () =>
        Yup.string()
          .email(t("validation:email_invalid"))
          .required(t("validation:required")),
    },
    // {
    //   name: "mfa",
    //   label: "Multi-Factor Authentication",
    //   initialValue: mfa,
    //   required: false,
    //   schema: () => null,
    //   toggle: true,
    // },
  ];

  return (
    <BasicForm
      buttonProps={{
        fullWidth: !id ? true : false,
      }}
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
